import React, { useRef } from "react";
import "./ourStory.css";

const OurStory = () => {
  const profileRef = useRef(null);

  const scrollToProfile = () => {
    profileRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="os-container">
      {/* Professional Internal CSS */}
      <style>
        {`
          .os-gallery-section {
            padding: 100px 5%;
            background: transparent;
            position: relative;
          }

          .os-gallery-header-container {
            text-align: center;
            margin-bottom: 60px;
          }

          .os-gallery-title {
            color: #fff200;
            font-family: 'Poppins', sans-serif;
            font-size: clamp(32px, 5vw, 50px);
            font-weight: 900;
            letter-spacing: -1px;
            margin: 0;
            text-transform: uppercase;
          }

          .os-gallery-line {
            width: 80px;
            height: 4px;
            background: #fff200;
            margin: 15px auto;
            border-radius: 2px;
          }

          /* Fixed 3-Column Grid for Desktop */
          .os-modern-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr); /* Exactly 3 images per row */
            auto-rows: 400px; /* Increased height for better 3-column proportions */
            gap: 30px;
            max-width: 1300px;
            margin: 0 auto;
          }

          .os-grid-card {
            position: relative;
            overflow: hidden;
            border-radius: 24px;
            background: #1a1a1a;
            cursor: pointer;
            transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
            animation: osReveal 0.8s ease-out both;
          }

          /* Professional Hover Effects */
          .os-grid-card:hover {
            transform: translateY(-15px);
            box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5), 0 0 20px rgba(255, 242, 0, 0.1);
          }

          .os-card-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            filter: grayscale(20%) brightness(0.9);
            transition: all 0.8s ease;
          }

          .os-grid-card:hover .os-card-img {
            filter: grayscale(0%) brightness(1.1);
            transform: scale(1.08);
          }

          /* Subtle Overlay Text */
          .os-card-overlay {
            position: absolute;
            inset: 0;
            display: flex;
            align-items: flex-end;
            padding: 40px;
            background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 60%);
            opacity: 0;
            transition: opacity 0.4s ease;
          }

          .os-grid-card:hover .os-card-overlay {
            opacity: 1;
          }

          .os-overlay-text {
            color: #fff;
            font-family: 'Poppins', sans-serif;
            font-weight: 600;
            font-size: 16px;
            letter-spacing: 3px;
            text-transform: uppercase;
            transform: translateY(10px);
            transition: transform 0.4s ease;
          }

          .os-grid-card:hover .os-overlay-text {
            transform: translateY(0);
          }

          @keyframes osReveal {
            from { opacity: 0; transform: translateY(50px); }
            to { opacity: 1; transform: translateY(0); }
          }

          /* Tablet & Mobile Responsiveness */
          @media (max-width: 1024px) {
            .os-modern-grid {
              grid-template-columns: repeat(2, 1fr); /* 2 per row for tablets */
              auto-rows: 350px;
            }
          }

          @media (max-width: 768px) {
            .os-modern-grid {
              grid-template-columns: 1fr; /* 1 per row for mobile */
              auto-rows: 300px;
              gap: 20px;
            }
            .os-gallery-section {
              padding: 60px 20px;
            }
          }
        `}
      </style>

      {/* Hero Section */}
      <h1 className="os-headline">
        Wondering <br /> what Zzayraat's all about ?
      </h1>
      <p className="os-subheadline">
        Lets break it down for you !
      </p>
      <div className="os-arrow" onClick={scrollToProfile}>
        <svg xmlns="http://www.w3.org/2000/svg" className="os-arrow-icon os-bounce" width="60" height="60" viewBox="0 0 60 60">
          <circle cx="30" cy="30" r="28" stroke="#fff2a8" strokeWidth="3" fill="none" />
          <polyline points="20,28 30,40 40,28" fill="none" stroke="#fff2a8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      {/* Profile Section */}
      <div ref={profileRef} className="os-profile-section">
        <h2 className="os-profile-title os-animate-fadein">IT ALL STARTED WITH A SPARK !</h2>
        <div className="os-profile-content">
          <div className="os-profile-image os-animate-slidein">
            <img src="/images/founder.jpg" alt="Mr Vivek CEO Founder" />
          </div>
          <div className="os-profile-text">
            <div className="os-profile-wrapper">
              <style>
                {`
                  @media (max-width: 768px) {
                    .os-profile-container, .os-vision-text {
                      text-align: center !important;
                      margin-left: auto !important;
                      margin-right: auto !important;
                      max-width: 100% !important;
                    }
                    .os-name-heading { font-size: 32px !important; }
                    .os-title-sub { font-size: 20px !important; }
                  }
                `}
              </style>

              <div className="os-profile-container" style={{ textAlign: 'left', padding: '10px' }}>
                <h3 className="os-name-heading" style={{ color: '#fff200', fontSize: '43px', fontFamily: "'Poppins', sans-serif", fontWeight: '800', margin: '0', lineHeight: '1.2' }}>
                  Mr. Vivek Kesarkar
                </h3>
                <p className="os-title-sub" style={{ color: '#fff200', fontSize: '28px', fontWeight: '600', fontFamily: "'Poppins', sans-serif", margin: '0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  CEO & Director
                </p>
              </div>

              <p className="os-vision-text" style={{ color: '#faf1c0ff', textAlign: 'left', fontSize: '22px', lineHeight: '1.8', fontWeight: '400', maxWidth: '80%', marginRight: 'auto', marginLeft: '0', marginTop: '20px', fontFamily: 'poppins, sans-serif' }}>
                A visionary with a relentless passion for storytelling, Mr. Vivek founded Zzayraat with a single mission to transform ideas into unforgettable brand journeys. With a keen eye for design and an instinct for what connects people to brands, he dreamed of building more than an agency a creative movement.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Modern Professional Gallery Section */}
      <div className="os-gallery-section">
        <div className="os-gallery-header-container">
          <h2 className="os-gallery-title">The Creative Portfolio</h2>
          <div className="os-gallery-line"></div>
        </div>

        <div className="os-modern-grid">
          {/* Manually Add Your Image Sources Below */}
          <div className="os-grid-card" style={{ animationDelay: '0.1s' }}>
            <img src="/images/gallery1.jpg" alt="Work 1" className="os-card-img" />
           
          </div>
          <div className="os-grid-card" style={{ animationDelay: '0.2s' }}>
            <img src="/images/img2.jpg" alt="Work 2" className="os-card-img" />
           
          </div>
          <div className="os-grid-card" style={{ animationDelay: '0.3s' }}>
            <img src="/images/img9.png" alt="Work 3" className="os-card-img" />
            
          </div>
         
          <div className="os-grid-card" style={{ animationDelay: '0.5s' }}>
            <img src="/images/img5.jpg" alt="Work 5" className="os-card-img" />
            
          </div>
          <div className="os-grid-card" style={{ animationDelay: '0.6s' }}>
            <img src="/images/img6.jpg" alt="Work 6" className="os-card-img" />
         
          </div>
          <div className="os-grid-card" style={{ animationDelay: '0.6s' }}>
            <img src="/images/img7.jpg" alt="Work 6" className="os-card-img" />
         
          </div>
         
        </div>
      </div>
    </div>
  );
};

export default OurStory;